"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectorCarousel = exports.LocationSelector = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
require("./styles/main.css");
/* Paginas */
var mapa_1 = __importDefault(require("./pages/mapa"));
var cidades_1 = __importDefault(require("./pages/cidades"));
var LocationSelector = function (_a) {
    var _b = _a.initialData, initialData = _b === void 0 ? [] : _b, emitData = _a.emitData;
    var _c = (0, react_1.useState)(0), page = _c[0], setPage = _c[1];
    var _d = (0, react_1.useState)(initialData), coverage = _d[0], setCoverage = _d[1];
    var _e = (0, react_1.useState)(null), selectedUF = _e[0], setSelectedUF = _e[1];
    (0, react_1.useEffect)(function () { setPage(!selectedUF ? 0 : 1); }, [selectedUF]);
    (0, react_1.useEffect)(function () { emitData(coverage); }, [coverage]);
    var after = function (cidades_result) {
        if (!cidades_result)
            return setSelectedUF(null);
        var id = selectedUF === null || selectedUF === void 0 ? void 0 : selectedUF.id;
        var payload = { id: id, cidades: cidades_result };
        setCoverage(function (prev) {
            var new_state = __spreadArray([], prev, true);
            var indexExists = (prev.findIndex(function (s) { return s.id == id; }));
            if (indexExists == -1)
                new_state.push(payload);
            else {
                new_state.splice(indexExists, 1, payload);
            }
            return new_state;
        });
        return setSelectedUF(null);
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: 'react-fck-br-location-selector' }, { children: (0, jsx_runtime_1.jsxs)(exports.SelectorCarousel, __assign({ index: page }, { children: [(0, jsx_runtime_1.jsx)(mapa_1.default, { current_state: coverage, onClick: setSelectedUF }, void 0), (0, jsx_runtime_1.jsx)(cidades_1.default, { current_state: coverage, id: (selectedUF === null || selectedUF === void 0 ? void 0 : selectedUF.id) ? selectedUF.id : -1, onEnd: after }, void 0)] }), void 0) }), void 0));
};
exports.LocationSelector = LocationSelector;
var SelectorCarousel = function (_a) {
    var children = _a.children, _b = _a.index, index = _b === void 0 ? 0 : _b;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: 'react-fck-br-location-selector-carousel-frame' }, { children: react_1.default.Children.map(children, function (x, i) {
            if (index === i)
                return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [" ", (x), " "] }, i);
        }) }), void 0));
};
exports.SelectorCarousel = SelectorCarousel;
exports.default = exports.LocationSelector;
//# sourceMappingURL=App.js.map